import { render, staticRenderFns } from "./BoardWritePage.vue?vue&type=template&id=7532cc26"
import script from "./BoardWritePage.ts?vue&type=script&lang=ts&external"
export * from "./BoardWritePage.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports